/*
 * Copyright (c) 2021.
 * 2iPartners SàRL and/or its affiliates.
 * All rights reserved.
 *
 * 2iPartners SàRL
 * Route de Compois 24,
 * 1252 Meinier
 * Suisse
 *
 * tel : +41 22 735 97 07
 */

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ReactiveFormsModule} from '@angular/forms';
import {CDKModule} from '../../cdk.module';
import {MaterialModule} from '../../material.module';
import {SelectsModule} from '../selects/selects.module';
import {InputsModule} from '../inputs/inputs.module';
import {DialogConfirmAutopsyComponent} from './dialog-confirm-autopsy/dialog-confirm-autopsy.component';
import {TablesModule} from '../tables/tables.module';
import {DisplaysModule} from '../displays/displays.module';
import {DialogRemovalFinishedComponent} from './dialog-removal-finished/dialog-removal-finished.component';
import {DialogRemovalValidateComponent} from './dialog-removal-validate/dialog-removal-validate.component';
import {ServicesModule} from '../../_services/services.module';
import {DialogThirdPartyLockedComponent} from './dialog-third-party-locked/dialog-third-party-locked.component';
import {DialogAngeeComponent} from './dialog-angee/dialog-angee.component';
import {DialogRemovalPointDisableComponent} from './dialog-removal-point-disable/dialog-removal-point-disable.component';
import {DialogRemovalPointEnableComponent} from './dialog-removal-point-enable/dialog-removal-point-enable.component';
import {DialogRemovalPointFavoriteComponent} from './dialog-removal-point-favorite/dialog-removal-point-favorite.component';
import {DialogRemovalPointFormComponent} from './dialog-removal-point-form/dialog-removal-point-form.component';
import {DialogBoviclicCancelComponent} from './dialog-boviclic-cancel/dialog-boviclic-cancel.component';
import {DialogAtmInvalidComponent} from './dialog-atm-invalid/dialog-atm-invalid.component';
import {DialogNotAllowedSiteComponent} from './dialog-not-allowed-site/dialog-not-allowed-site.component';
import {DialogUserEmailUsedComponent} from './dialog-user-email-used/dialog-user-email-used.component';

@NgModule({
  declarations: [
    DialogAngeeComponent,
    DialogAtmInvalidComponent,
    DialogBoviclicCancelComponent,
    DialogConfirmAutopsyComponent,
    DialogNotAllowedSiteComponent,
    DialogRemovalFinishedComponent,
    DialogRemovalValidateComponent,
    DialogRemovalPointDisableComponent,
    DialogRemovalPointEnableComponent,
    DialogRemovalPointFavoriteComponent,
    DialogRemovalPointFormComponent,
    DialogThirdPartyLockedComponent,
    DialogUserEmailUsedComponent
  ],

  exports: [
    DialogAngeeComponent,
    DialogAtmInvalidComponent,
    DialogBoviclicCancelComponent,
    DialogConfirmAutopsyComponent,
    DialogNotAllowedSiteComponent,
    DialogRemovalFinishedComponent,
    DialogRemovalValidateComponent,
    DialogRemovalPointDisableComponent,
    DialogRemovalPointEnableComponent,
    DialogRemovalPointFavoriteComponent,
    DialogRemovalPointFormComponent,
    DialogThirdPartyLockedComponent,
    DialogUserEmailUsedComponent
  ],
  imports: [
    CDKModule,
    CommonModule,
    DisplaysModule,
    InputsModule,
    MaterialModule,
    ReactiveFormsModule,
    SelectsModule,
    ServicesModule,
    TablesModule
  ]
})

export class DialogsModule {
}
